import { toItem } from '../mappers/item';
export function parseItems(res) {
  const data = res.data;
  const remainingItemsCount = data.total_count - data.page * data.per_page;
  const cursor = remainingItemsCount > 0 ? data.page + 1 : null;
  const size = data.per_page;
  res.data = (data.data || []).map(item => ({
    ...toItem(item),
    hasMoreItemsInThisCategory: cursor !== null
  }));
  res.paging = {
    cursor,
    size
  };
  return res;
}